import { Controller } from "@hotwired/stimulus"

// Il catalogo riletto con morph (refresh dallo stream :catalogo, elenco riletto dopo un'eliminazione o il controllo
// delle fonti) resta com'era per chi lo guarda, come lo stato di React dopo load(): dettagli e finestre aperti restano
// aperti, le opzioni scelte nei filtri restano scelte e i filtri si riapplicano alle schede rilette.
export default class extends Controller {
  static CONSERVATI = ["open", "selected"]

  disconnect() { clearTimeout(this.timer) }

  attributo(event) {
    if (this.constructor.CONSERVATI.includes(event.detail.attributeName)) event.preventDefault()
  }

  aggiornato() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.element.querySelectorAll("[data-controller~='filtri-catalogo']").forEach((barra) => {
        barra.dispatchEvent(new Event("change", { bubbles: true }))
      })
    }, 0)
  }
}
